import {
  ADD_PARTICIPANT,
  ADD_STREAM_DETECTION,
  CLEAR_FF_DATA,
  DELETE_PARTICIPANT,
  DELETE_STREAM_DETECTION,
  MUTE_CAMERA,
  MUTE_MICRO,
  SET_STREAM,
  UPDATE_STREAM_DETECTION,
} from '../constants';

const initialState = {
  isCameraMuted: false,
  isMicrophoneMuted: false,
  roomParticipants: [],
  stream: null,
  streamDetection: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_FF_DATA: {
      state.streamDetection.forEach((item) => clearInterval(item.intervallink));
      return { ...initialState };
    }
    case MUTE_MICRO: {
      return { ...state, isMicrophoneMuted: action.payload };
    }
    case MUTE_CAMERA: {
      return { ...state, isCameraMuted: action.payload };
    }
    case SET_STREAM: {
      return { ...state, stream: action.payload };
    }
    case ADD_STREAM_DETECTION: {
      const newData = [...state.streamDetection, action.payload];
      return { ...state, streamDetection: newData };
    }
    case UPDATE_STREAM_DETECTION: {
      const newData = action.payload;
      const result = state.streamDetection.map((item) =>
        item.streamId === newData.streamId ? { ...item, ...newData } : item
      );
      return { ...state, streamDetection: result };
    }
    case DELETE_STREAM_DETECTION: {
      const streamId = action.payload.name();
      const el = state.streamDetection.find((item) => item.streamId === streamId);
      if (el) clearInterval(el.intervallink);
      const result = state.streamDetection.filter((item) => item.streamId !== streamId);
      return { ...state, streamDetection: result };
    }

    case ADD_PARTICIPANT: {
      const newData = [...state.roomParticipants, action.payload];
      return { ...state, roomParticipants: newData };
    }
    case DELETE_PARTICIPANT: {
      const newData = state.roomParticipants.filter((item) => item.name !== action.payload);
      return { ...state, roomParticipants: newData };
    }

    default: {
      return state;
    }
  }
};
